import * as actionTypes from '../actions/filters';

const initialState = {
  portfolios: [],
  years: [],
  managers: [],
  indicators: [],
  selectedFilters: {
    siIndicators: [],
    portfolioIds: [],
    relationshipMgrs: [],
    portfolioYears: []
  },
  appliedFilters: [],
  databaseFilters: [],
  services: [],
};

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_PORTFOLIOS_SUCCESS: {
      const { portfolios: results } = action.payload.data.data;
      const portfolios = results.map(item => ({
        id: item.portfolioId,
        name: item.name,
        year: item.year
      }));
      const years = results.reduce((all, item) => {
        if (all.indexOf(item.year) === -1) all.push(item.year);
        return all;
      }, []).sort();
      const managers = results.reduce((all, item) => {
        if (item.relationshipManager) {
          all.push({
            id: item.relationshipManager.accountId,
            name: `${item.relationshipManager.firstName} ${item.relationshipManager.lastName}`
          });
        }
        return all;
      }, []).sort();
      return {
        ...state,
        portfolios,
        years,
        managers
      };
    }
    case actionTypes.GET_INDICATORS_SUCCESS: { 
      const indicators = action.payload.data.data
        .sort((a, b) => (b['Claims.totalClaim'] > a['Claims.totalClaim']) ? 1 : -1)
        .map(
          item => item['Indicators.name']
        );
      return {
        ...state,
        indicators
      };
    }
    case actionTypes.GET_SERVICES_SUCCESS: {
      const services = action.payload.data.data.map(
        item => item['Services.name']
      );
      return {
        ...state,
        services
      };
    }
    case actionTypes.SET_FILTERS_SUCCESS: {
      return {
        ...state,
        selectedFilters: action.payload.data
      };
    }
    case actionTypes.APPLY_FILTERS_SUCCESS: {
      return {
        ...state,
        appliedFilters: action.payload.data
      };
    }
    case actionTypes.GET_FILTERS_SUCCESS: {
      const databaseFilters = action.payload.data.data.map(item => ({
        id: item.id,
        name: item.attributes.name,
        template: item.attributes.template
      }));
      return {
        ...state,
        databaseFilters
      };
    }
    default: {
      return state;
    }
  }
};

export default filterReducer;
